<template>
  <footer class="front-footer">
    <div class="d-flex justify-content-between">
      <div class="copyright">@copyrigh 2020 All rights reserved 此網站不為商業用所用</div>
      <div>
        <ul class="d-flex justify-content-between">
          <li>
            <a href="https://abc820219.github.io/" target="_blank">
              <font-awesome-icon :icon="['fab', 'github']" />
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/profile.php?id=100001831706318"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'facebook']" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/?hl=zh-tw" target="_blank">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
